import React from "react";
export default function Star({
  size,
  isFavorite,
  ...rest
}: {
  size?: number;
  isFavorite: boolean;
  [x: string]: any;
}) {
  return isFavorite ? (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.322 5.56856H10.221L8.64357 0.48928C8.44089 -0.163093 7.5584 -0.163093 7.35572 0.48928L5.77958 5.56856H0.678527C0.0226414 5.56856 -0.250534 6.44763 0.28072 6.85091L4.40738 9.99021L2.83124 15.0695C2.62856 15.7219 3.34235 16.2649 3.87361 15.8616L8.00028 12.7223L12.1269 15.8616C12.6582 16.2649 13.372 15.7219 13.1693 15.0695L11.5932 9.99021L15.7198 6.85091C16.2498 6.44763 15.9779 5.56856 15.322 5.56856Z"
        fill="#AEE3FA"
      />
    </svg>
  ) : (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.221 6.06856C10.002 6.06856 9.80843 5.92602 9.74347 5.71686L8.16609 0.637628C8.16608 0.637609 8.16608 0.63759 8.16607 0.637571C8.1471 0.576538 8.11845 0.546099 8.09512 0.529472C8.06908 0.510908 8.03581 0.5 7.99965 0.5C7.96349 0.5 7.93021 0.510908 7.90417 0.529472C7.88086 0.546089 7.85223 0.576502 7.83326 0.637463L10.221 6.06856ZM10.221 6.06856H15.322C15.3686 6.06856 15.398 6.08232 15.4206 6.10064C15.4468 6.12189 15.4729 6.1577 15.488 6.20649C15.519 6.30639 15.491 6.39677 15.4171 6.45301L11.2904 9.59227C11.1232 9.71949 11.0534 9.9377 11.1156 10.1384L12.6918 15.2177L12.6918 15.2178C12.726 15.3277 12.6863 15.4136 12.6208 15.4634C12.5873 15.4888 12.5535 15.4991 12.5266 15.4999C12.5041 15.5007 12.472 15.4957 12.4295 15.4635C12.4294 15.4634 12.4293 15.4634 12.4293 15.4633L8.303 12.3243C8.12413 12.1883 7.87643 12.1883 7.69755 12.3243L3.57129 15.4633C3.57126 15.4633 3.57122 15.4634 3.57119 15.4634C3.52858 15.4957 3.49643 15.5007 3.47395 15.4999C3.44709 15.4991 3.41327 15.4888 3.3798 15.4634C3.3143 15.4136 3.27461 15.3277 3.30873 15.2178L3.30878 15.2177L4.88492 10.1384C4.94719 9.9377 4.87735 9.71949 4.71011 9.59227L0.583447 6.45297L0.583039 6.45266C0.508872 6.39636 0.481052 6.30633 0.511966 6.20675C0.527095 6.15801 0.553279 6.12213 0.579636 6.10078C0.602399 6.08235 0.631976 6.06856 0.678527 6.06856H5.77958C5.99864 6.06856 6.1922 5.92597 6.25712 5.71675L7.83321 0.637628L10.221 6.06856Z"
        stroke="#8B8E9F"
        strokeLinejoin="round"
      />
    </svg>
  );
}
